import React, { useEffect, useState } from "react";
import { IconButton, Dialog } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from "../../constants/theme";

import CardsTable from "../cards_table";
import ChargeInfo from "./charge_info";
import TabHeader from "../tab_header";

const CardRechargeSection = ({ cards = [], 
  chargeOption, 
  charge, 
  openCharge, 
  onCancel,
  toggleCharge
 }) => {

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [chargeType, setChargeType] = useState(0)
  const [selectedCards, setSelectedCards] = useState([])

  useEffect(() => {
    setSelectedCards(cards.map(c => (c.cardNumber)))
  }, [cards])

  return (
    <div className="card_recharge_section">
      <div className="cards">
        {
          chargeOption === 'togrog' && 
          <div className="d-flex align-items-center px-4 py-3">
            <TabHeader 
              chargeType={chargeType}
              setChargeType={setChargeType}
              items={['Жолооч тус бүрт ноогдох дүн', 'Оруулсан мөнгөн дүнг тэнцүү хуваах', 'Тус тус өөр дүнгээр']}
            />
            <IconButton
              variant="outlined"
              onClick={() => toggleCharge(true)}
              className="d-flex d-sm-none btn-bordered bg-primary me-2"
            >
              <i className='bx bx-right-arrow-alt text-white font-size-20 px-2'></i>
            </IconButton>
          </div>
        }
        <div>
          <CardsTable 
            showHeader={false}
            selectable={true}
            tableData={cards}
            setSelectedCards={setSelectedCards}
            selectedCards={selectedCards}/>
        </div>
      </div>
      {
        chargeType !== 2 && <div className="d-none d-lg-flex flex-column charge-info">
          <ChargeInfo 
            chargeOption={chargeOption}
            type={chargeType}
            charge={charge}
          />
        </div>
      }
      <Dialog 
        maxWidth="xs"
        fullScreen={fullScreen ?? false} 
        open={openCharge && chargeType !== 2} 
        onClose={onCancel}
      >
        <ChargeInfo 
          chargeOption={chargeOption}
          type={chargeType}
          charge={charge}
          isDialog={true}
          onCancel={onCancel}
        />
      </Dialog>
    </div>
  );
};

export default CardRechargeSection;
